export const getSubmitting = (state) => state.rfidFileUpload.submitting;

export const getValidation = (state) => state.rfidFileUpload.validation;

export const getSubmitted = (state) => state.rfidFileUpload.submitted;
